import styled from 'styled-components';
import { motion } from 'framer-motion';

export const PrivacySection = styled(motion.section)`
  padding: 10rem 5rem 8rem;
  max-width: 1320px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 10rem 1.5rem 4rem;
  }
`;

export const PrivacyTitle = styled(motion.h1)`
  font-size: 3rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 1rem;
  letter-spacing: 0.5px;
  text-transform: uppercase;

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

export const LastUpdated = styled.p`
  font-size: 1.1rem;
  color: #6b7280;
  margin-bottom: 4rem;
`;

export const SectionHeading = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin: 3rem 0 1rem;
`;

export const SectionText = styled.p`
  font-size: 1.1rem;
  color: #4b5563;
  margin-bottom: 1.5rem;
  line-height: 1.8;
`;

export const List = styled.ol`
  padding-left: 2rem;
  margin-bottom: 2rem;
`;

export const ListItem = styled.li`
  font-size: 1.1rem;
  color: #4b5563;
  margin-bottom: 1rem;
  line-height: 1.8;
`;
